module.exports = __webpack_public_path__ + "img/realname_4.7b002650.png";